import { EventEmitter } from 'events'

class MapTools extends EventEmitter {
  static apiKey='D2MBZ-UNXKL-LHZPE-ER57V-RIEKQ-K2FMU'

  base=''
  center={ lat: 34.309615, lng: 108.923302 }
  zoom=5
  map=null

  markerLayer=null // 标注图层
  circleLayer=null // 商圈图层
  labelLayer=null // 文本图层

  tempLayer=null // 添加标注点的临时图层
  tempCircleLayer=null // 添加标注点的临时商圈图层
  polygonLayer=null // 行政区划边界图层
  currentBoundaryCode=null // 当前显示边界的区划编码

  measureTool=null // 测量工具
  measureMode='none' // 测量模式
  isMeasuring=false // 是否正在测量

  isAddingStore=false // 是否处于添加门店模式

  // 新增：交互模式管理
  interactionMode='browse' // 当前交互模式: browse|measure|add|search
  tempMarker=null // 临时标注点对象
  tempCircle=null // 临时商圈对象

  currentInfoWindow=null // 当前打开的信息窗口

  _brandFilters=['美滋滋', '蛮碗香', '长安大东家', '虎头张', '代运营'] // 选中的品牌
  _visibleFilters=['正常门店', '解约门店', '临时门店']
  _showRange=false // 是否隐藏商圈

  storeList=[]
  _labelStyleCache={} // 标签样式预计算缓存（避免每次refresh随机）
  _refreshTimer=null // 防抖刷新定时器
  circleZoomThreshold=10 // 商圈圆显示的最小缩放级别

  markerStyleConfig= { // 标注点的基础设置
    width: 30,
    height: 42,
    scaleZoom: 8,
    minScale: 0.45,
    maxScale: 1
  }

  brandColors = {
    美滋滋: { backgroundColor: 'rgba(255, 0, 204, 0.5)', color: 'rgba(255, 0, 204, 1)' },
    蛮碗香: { backgroundColor: 'rgba(0, 153, 255, 0.5)', color: 'rgba(0, 153, 255, 1)' },
    虎头张: { backgroundColor: 'rgba(255, 102, 0, 0.5)', color: 'rgba(255, 102, 0, 1)' },
    代运营: { backgroundColor: 'rgba(255, 204, 0, 0.5)', color: 'rgba(255, 204, 0, 1)' },
    长安大东家: { backgroundColor: 'rgba(153, 0, 255, 0.5)', color: 'rgba(153, 0, 255, 1)' },
    临时1: { backgroundColor: 'rgba(0, 204, 255, 0.5)', color: 'rgba(0, 204, 255, 1)' },
    临时2: { backgroundColor: 'rgba(39, 188, 28, 0.5)', color: 'rgba(39, 188, 28, 1)' },
    临时3: { backgroundColor: 'rgba(255, 0, 51, 0.5)', color: 'rgba(255, 0, 51, 1)' },
    临时4: { backgroundColor: 'rgba(0, 0, 255, 0.5)', color: 'rgba(0, 0, 255, 1)' },
    // 解约: { backgroundColor: 'rgba(235, 5, 50, 0.5)', color: 'rgba(235, 5, 50, 1)' },
    解约: { backgroundColor: 'rgba(22, 223, 112, 0.5)', color: 'rgba(22, 223, 112, 1)' },
    临时: { backgroundColor: 'rgba(39, 188, 28, 0.5)', color: 'rgba(39, 188, 28, 1)' }
  }

  constructor (container, base) {
    super()
    this.base = base
    this.initMap(container)
  }

  get brandFilters () {
    return this._brandFilters
  }

  set brandFilters (filters) {
    this._brandFilters = filters
    if (this.storeList && this.storeList.length > 0) {
      this.refresh()
    }
  }

  get visibleFilters () {
    return this._visibleFilters
  }

  set visibleFilters (filters) {
    this._visibleFilters = filters
    if (this.storeList && this.storeList.length > 0) {
      this.refresh()
    }
  }

  // 是否显示商圈（别名，与Map.vue保持一致）
  get showCircle () {
    return this._showRange
  }

  set showCircle (need) {
    this._showRange = need
    this.refresh()
  }

  /**
   * 地图初始化
   * @param {*} container 容器
   * @param {*} baseUrl 图标基础路径
   * @returns
   */
  initMap (container) {
    // 初始化地图
    this.map = new window.TMap.Map(container, {
      zoom: this.zoom, // 设置地图缩放级别
      center: new window.TMap.LatLng(this.center.lat, this.center.lng), // 设置地图中心点坐标
      showControl: false
    })

    // 创建统一的标记点图层
    this.markerLayer = new window.TMap.MultiMarker({
      map: this.map,
      styles: this.createMarkerStyleObj(),
      isStopPropagation: true,
      geometries: []
    })
    this.markerLayer.on('click', this.onMarkerClick.bind(this))

    // 创建商圈圆形图层
    this.circleLayer = new window.TMap.MultiCircle({
      map: this.map,
      styles: this.createCircleStyleObj(),
      geometries: []
    })

    // 创建文本图层
    this.labelLayer = new window.TMap.MultiLabel({
      map: this.map,
      styles: this.createLabelStyleObj(),
      isStopPropagation: true,
      geometries: []
    })
    this.labelLayer.setVisible(false)
    this.labelLayer.on('click', this.onLabelClick.bind(this))

    // 创建临时标记点图层
    this.tempLayer = new window.TMap.MultiMarker({
      map: this.map,
      // styles: {
      //   mark_临时: new window.TMap.MarkerStyle({
      //     width: 60,
      //     height: 84,
      //     src: this.base + '/public/t1.png',
      //     anchor: { x: 30, y: 84 }
      //   })
      // },
      geometries: []
    })

    // 创建临时商圈图层
    this.tempCircleLayer = new window.TMap.MultiCircle({
      map: this.map,
      styles: this.createCircleStyleObj(),
      geometries: []
    })

    // 创建测量工具（需要检查 TMap.tools 是否已加载）
    if (window.TMap && window.TMap.tools && window.TMap.tools.MeasureTool) {
      this.measureTool = new window.TMap.tools.MeasureTool({
        map: this.map
      })
    }

    // 创建行政区划边界图层
    const boundaryStyles = {
      province: new window.TMap.PolygonStyle({
        color: 'rgba(255, 140, 0, 0.1)',
        showBorder: true,
        borderColor: 'rgba(255, 100, 0, 0.6)',
        borderWidth: 2
      }),
      city: new window.TMap.PolygonStyle({
        color: 'rgba(255, 50, 50, 0.12)',
        showBorder: true,
        borderColor: 'rgba(255, 30, 30, 0.6)',
        borderWidth: 2
      }),
      district: new window.TMap.PolygonStyle({
        color: 'rgba(200, 0, 100, 0.15)',
        showBorder: true,
        borderColor: 'rgba(180, 0, 90, 0.7)',
        borderWidth: 2
      })
    }
    this.polygonLayer = new window.TMap.MultiPolygon({
      map: this.map,
      styles: boundaryStyles,
      geometries: []
    })

    this.map.on('zoom', this.onZoom.bind(this))
    this.map.on('click', this.onMapClick.bind(this))
    this.map.on('moveend', this.onMoveEnd.bind(this))
  }

  /**
   * 地图点击事件处理
   * @param {*} e
   */
  onMapClick (e) {
    // console.log('地图被点击了', e.latLng)
    // 关闭信息窗口
    this.closeInfoWindow()
  }

  /**
   * 标记点点击事件处理
   * @param {*} e
   */
  onMarkerClick (e) {
    // console.log('标记点被点击了', e.geometry.properties)
    this.showStoreInfo(e.geometry.properties)
  }

  /**
   * 标签点击事件处理
   * @param {*} e
   */
  onLabelClick (e) {
    // console.log('标签被点击了', e.geometry.properties)
    this.showStoreInfo(e.geometry.properties)
  }

  /**
   * 地图缩放事件处理
   * @param {*} e
   */
  onZoom (e) {
    const currentZoom = this.map.getZoom()
    if (currentZoom > 11.5) {
      this.labelLayer.setVisible(true)
    } else {
      this.labelLayer.setVisible(false)
    }
    // 缩放变化时重新渲染（可能跨过商圈显示阈值）
    this.debouncedRefresh()
  }

  /**
   * 地图拖动结束事件处理（触发视口裁剪刷新）
   */
  onMoveEnd () {
    this.debouncedRefresh()
  }

  /**
   * 防抖刷新（避免频繁拖动/缩放导致过多渲染）
   */
  debouncedRefresh () {
    if (this._refreshTimer) {
      clearTimeout(this._refreshTimer)
    }
    this._refreshTimer = setTimeout(() => {
      this._refreshTimer = null
      this.refresh()
    }, 200)
  }

  /**
   * 判断坐标是否在当前地图视口内
   * @param {number} lat - 纬度
   * @param {number} lng - 经度
   * @param {Object} bounds - 地图边界对象（可选，避免重复获取）
   * @returns {boolean}
   */
  isInViewport (lat, lng, bounds) {
    if (!bounds) return true
    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()
    return lat <= ne.getLat() && lat >= sw.getLat() &&
      lng <= ne.getLng() && lng >= sw.getLng()
  }

  // 显示门店信息
  showStoreInfo (storeInfo) {
    // 关闭之前打开的信息窗口
    this.closeInfoWindow()

    // 判断是否为临时门店
    const isTempStore = storeInfo.projectId == null
    // 是否为解约门店
    const isUnsignStore = storeInfo.flag === 0

    let buttons = ''

    if (isUnsignStore) {
      buttons = `
        <div class="store-info-actions">
          <button class="store-delete-btn" onclick="window.handleCloseStore('${storeInfo._id}', '${storeInfo.projectName}')">关闭门店</button>
          <button class="store-modify-range-btn" onclick="window.handleModifyRange('${storeInfo._id}')">修改商圈</button>
        </div>
      `
    } else if (isTempStore) {
      buttons = `
        <div class="store-info-actions">
          <button class="store-delete-btn" onclick="window.handleDeleteStore('${storeInfo._id}', '${storeInfo.projectName}')">删除</button>
          <button class="store-modify-range-btn" onclick="window.handleModifyRange('${storeInfo._id}')">修改商圈</button>
        </div>
        
      `
    } else {
      buttons = `
        <div class="store-info-actions">
          <button class="store-modify-range-btn" onclick="window.handleModifyRange('${storeInfo._id}')">修改商圈</button>
        </div>
              `
    }

    const content = `
        <div class="store-info-popup">
          <h3>${storeInfo.projectName || '未知门店'}</h3>
          <p>${storeInfo.area || ''}-${storeInfo.province || ''}-${storeInfo.city || ''}-${storeInfo.district || ''}</p>
          <p><strong>地址:</strong> ${storeInfo.address || '未知地址'}</p>
          <p><strong>品牌:</strong> ${storeInfo.brand || ''}</p>
          <p><strong>商圈范围:</strong> ${storeInfo.range || 0} 公里</p>
          <p><strong>签约人:</strong> ${storeInfo.signerName || '无'}</p>
          ${buttons}
        </div>
      `

    // 创建信息窗口
    this.currentInfoWindow = new window.TMap.InfoWindow({
      map: this.map,
      position: new window.TMap.LatLng(storeInfo.lat, storeInfo.lng),
      content: content,
      offset: { x: 0, y: -40 }
    })

    this.map.setCenter(new window.TMap.LatLng(storeInfo.lat, storeInfo.lng))
    if (this.map.getZoom() < 12) {
      this.map.easeTo({ zoom: 12 }, { duration: 500 })
    }

    // 打开信息窗口
    this.currentInfoWindow.open()
  }

  // 关闭信息窗口
  closeInfoWindow () {
    if (this.currentInfoWindow) {
      this.currentInfoWindow.close()
      this.currentInfoWindow.destroy()
      this.currentInfoWindow = null
    }
  }

  /**
   * 创建标记点样式对象
   */
  createMarkerStyleObj () {
    const urls = {
      mark_美滋滋: '/public/mei.png',
      mark_美滋滋_解约: '/public/mei1.png',
      mark_蛮碗香: '/public/man.png',
      mark_蛮碗香_解约: '/public/man1.png',
      mark_虎头张: '/public/hu.png',
      mark_虎头张_解约: '/public/hu1.png',
      mark_代运营: '/public/dai.png',
      mark_代运营_解约: '/public/dai1.png',
      mark_长安大东家: '/public/chang.png',
      mark_长安大东家_解约: '/public/chang1.png',
      mark_临时1: '/public/t1.png',
      mark_临时2: '/public/t2.png',
      mark_临时3: '/public/t3.png',
      mark_临时4: '/public/t4.png'
    }
    const styles = {}
    for (const key in urls) {
      styles[key] = this.createMarkerStyle(urls[key])
    }

    return styles
  }

  /**
   * 创建标记点样式
   * @returns
   */
  createMarkerStyle (iconUrl) {
    const { width, height, scaleZoom, minScale, maxScale } = this.markerStyleConfig
    const x = width / 2
    const y = height

    return new window.TMap.MarkerStyle({
      width: width,
      height: height,
      src: this.base + iconUrl,
      anchor: { x: x, y: y },
      enableRelativeScale: true,
      relativeScaleOptions: {
        scaleZoom: scaleZoom,
        minScale: minScale,
        maxScale: maxScale
      }
    })
  }

  /**
   * 获取标记点样式
   * @param {*} storeData
   */
  getMarkerStyle (storeData) {
    const projectId = storeData.projectId
    const brand = storeData.brand
    const flag = storeData.flag

    if (!projectId) {
      return 'mark_临时2'
    } else if (flag === 0) {
      return `mark_${brand}_解约`
    } else if (brand !== '') {
      return `mark_${brand}`
    } else {
      return 'mark_临时4'
    }
  }

  /**
   * 创建商圈样式对象
   */
  createCircleStyleObj () {
    const colors = {
      circle_美滋滋: this.brandColors['美滋滋'],
      circle_蛮碗香: this.brandColors['蛮碗香'],
      circle_虎头张: this.brandColors['虎头张'],
      circle_代运营: this.brandColors['代运营'],
      circle_长安大东家: this.brandColors['长安大东家'],
      circle_临时1: this.brandColors['临时1'],
      circle_临时2: this.brandColors['临时2'],
      circle_临时3: this.brandColors['临时3'],
      circle_临时4: this.brandColors['临时4'],
      circle_解约: this.brandColors['解约']
    }

    const styles = {}
    for (const key in colors) {
      styles[key] = this.creaetCircleStyle(colors[key].backgroundColor, colors[key].color)
    }
    return styles
  }

  /**
   * 创建商圈样式
   * @param {*} backgroundColor
   * @param {*} color
   * @returns
   */
  creaetCircleStyle (backgroundColor, color) {
    return new window.TMap.CircleStyle({
      color: backgroundColor,
      showBorder: true,
      borderColor: color,
      borderWidth: 1
    })
  }

  /**
   * 根据门店数据获取商圈样式
   * @param {*} storeData
   */
  getCircleStyle (storeData) {
    const projectId = storeData.projectId
    const brand = storeData.brand
    const flag = storeData.flag

    if (!projectId) {
      return 'circle_临时2'
    } else if (flag === 0) {
      return 'circle_解约'
    } else if (brand !== '') {
      return `circle_${brand}`
    } else {
      return 'circle_临时4'
    }
  }

  /**
   * 创建标签样式对象
   */
  createLabelStyleObj () {
    const alignments = {
      美滋滋1: { align: 'left', color: this.brandColors['美滋滋'].color },
      美滋滋2: { align: 'center', color: this.brandColors['美滋滋'].color },
      美滋滋3: { align: 'right', color: this.brandColors['美滋滋'].color },
      蛮碗香1: { align: 'left', color: this.brandColors['蛮碗香'].color },
      蛮碗香2: { align: 'center', color: this.brandColors['蛮碗香'].color },
      蛮碗香3: { align: 'right', color: this.brandColors['蛮碗香'].color },
      虎头张1: { align: 'left', color: this.brandColors['虎头张'].color },
      虎头张2: { align: 'center', color: this.brandColors['虎头张'].color },
      虎头张3: { align: 'right', color: this.brandColors['虎头张'].color },
      代运营1: { align: 'left', color: this.brandColors['代运营'].color },
      代运营2: { align: 'center', color: this.brandColors['代运营'].color },
      代运营3: { align: 'right', color: this.brandColors['代运营'].color },
      长安大东家1: { align: 'left', color: this.brandColors['长安大东家'].color },
      长安大东家2: { align: 'center', color: this.brandColors['长安大东家'].color },
      长安大东家3: { align: 'right', color: this.brandColors['长安大东家'].color }
    }

    const styles = {}
    for (const key in alignments) {
      styles[key] = this.createLabelStyle(alignments[key].color, alignments[key].align)
    }
    return styles
  }

  /**
   * 创建标签样式
   */
  createLabelStyle (color, align) {
    const offset = { x: 0, y: 12 }
    if (align === 'left') {
      offset.x = 50
    } else if (align === 'right') {
      offset.x = -50
    } else {
      offset.y = 24
    }

    return new window.TMap.LabelStyle({
      size: 12,
      padding: '5px 10px',
      offset: offset,
      backgroundColor: '#fff',
      borderColor: color,
      color: color,
      borderWidth: 2,
      borderRadius: 5
    })
  }

  getLabelStyle (storeData) {
    return this._labelStyleCache[storeData._id] || '美滋滋1'
  }

  /**
   * 设置门店列表
   * @param {*} list
   */
  setStoreList (list) {
    this.map.setZoom(5)
    this.map.easeTo({ center: new window.TMap.LatLng(this.center.lat, this.center.lng), zoom: this.zoom })
    this.storeList = list

    // 预计算标签样式（避免每次refresh调用Math.random）
    this._labelStyleCache = {}
    for (const item of list) {
      const random = Math.floor(Math.random() * 3) + 1
      this._labelStyleCache[item._id] = `${item.brand}${random}`
    }

    this.refresh()
  }

  /**
   * 添加一个标注点
   * @param {*} storeData
   */
  addStore (storeData) {
    this.storeList.push(storeData)
    this.refresh()
  }

  /**
   * 移除一个标注点
   * @param {*} storeId
   */
  removeStore (storeId) {
    this.storeList = this.storeList.filter(store => store._id !== storeId)
    this.refresh()
  }

  /**
   * 根据id查找门店数据
   * @param {*} storeId
   * @returns
   */
  findStoreById (storeId) {
    return this.storeList.find(store => store._id === storeId)
  }

  /**
   * 更新商圈范围
   * @param {*} storeId
   * @param {*} newRange
   */
  updateStoreRange (storeId, newRange) {
    const store = this.findStoreById(storeId)
    if (store) {
      store.range = newRange
      this.refresh()
    }
  }

  /**
   * 过滤出需要显示的门店
   */
  filterStore () {
    const res = {
      marks: [],
      circles: [],
      labels: []
    }

    const currentZoom = this.map.getZoom()
    const showCircles = this._showRange && currentZoom >= this.circleZoomThreshold
    const bounds = this.map.getBounds()

    for (const item of this.storeList) {
      const brand = item.brand
      let visible = '未知'

      if (!item.projectId) {
        visible = '临时门店'
      } else if (item.flag === 0) {
        visible = '解约门店'
      } else {
        visible = '正常门店'
      }

      if (!this._brandFilters.includes(brand) || !this._visibleFilters.includes(visible)) {
        continue
      }

      // 视口裁剪：跳过不在当前视口内的门店
      if (!this.isInViewport(item.lat, item.lng, bounds)) {
        continue
      }

      const ll = new window.TMap.LatLng(item.lat, item.lng)

      res.marks.push({
        id: item._id,
        styleId: this.getMarkerStyle(item),
        position: ll,
        properties: item
      })

      // 商圈圆只在缩放级别足够时渲染
      if (showCircles) {
        res.circles.push({
          id: item._id,
          styleId: this.getCircleStyle(item),
          center: ll,
          radius: item.range * 500,
          properties: item
        })
      }

      res.labels.push({
        id: item._id,
        styleId: this.getLabelStyle(item),
        content: `${item.projectName}`,
        position: ll,
        properties: item
      })
    }

    return res
  }

  refresh () {
    this.markerLayer.setGeometries([])
    this.circleLayer.setGeometries([])
    this.labelLayer.setGeometries([])

    const stores = this.filterStore()
    this.markerLayer.setGeometries(stores.marks)
    this.circleLayer.setGeometries(stores.circles)
    this.labelLayer.setGeometries(stores.labels)
  }

  /**
   * 设置交互模式
   * @param {string} mode - 交互模式: browse|measure|add|search
   */
  setInteractionMode (mode) {
    // 如果当前模式与目标模式相同，则不处理
    if (this.interactionMode === mode) {
      return true
    }

    // 检查是否有冲突的操作正在进行
    if ((mode === 'measure' && this.isMeasuring) ||
        (mode === 'add' && this.isAddingStore) ||
        (mode === 'search' && (this.isMeasuring || this.isAddingStore))) {
      this.emit('error', '请先结束当前操作')
      return false
    }

    // 退出当前模式
    this.exitCurrentMode()

    // 进入新模式
    this.interactionMode = mode
    this.applyModeSettings()

    return true
  }

  /**
   * 退出当前模式
   */
  exitCurrentMode () {
    switch (this.interactionMode) {
      case 'measure':
        if (this.measureTool && this.isMeasuring) {
          this.measureTool.cancel()
          this.isMeasuring = false
          this.measureMode = 'none'
        }
        break
      case 'add':
        this.stopAddStoreMode()
        break
      case 'search':
        this.clearTempMarker()
        break
    }
  }

  /**
   * 应用模式设置（光标样式等）
   */
  applyModeSettings () {
    switch (this.interactionMode) {
      case 'browse':
        this.setMapCursor('default')
        break
      case 'measure':
        this.setMapCursor('crosshair')
        break
      case 'add':
        this.setMapCursor('crosshair')
        break
      case 'search':
        this.setMapCursor('default')
        break
    }
  }

  /**
   * 开始添加门店模式
   * @returns {boolean} 是否成功启动
   */
  startAddStoreMode () {
    // 检查是否正在测量或已处于添加模式
    if (this.isMeasuring || this.isAddingStore) {
      this.emit('error', '请先结束当前操作')
      return false
    }

    this.isAddingStore = true
    this.setMapCursor('crosshair')

    // 使用map.once绑定一次性点击事件（触发后自动解绑）
    this.map.once('click', (evt) => {
      const { lat, lng } = evt.latLng
      // 发出事件，携带经纬度
      this.emit('map-click-for-add', { lat, lng })
    })

    return true
  }

  /**
   * 创建临时标注点
   * @param {Object} position - 位置对象 {lat, lng}
   * @param {string} title - 标注点标题
   */
  createTempMarker (position, title = '临时标注点') {
    // 先清除已存在的临时标注点
    this.clearTempMarker()

    // 创建临时标注点几何对象
    const markerGeometry = {
      id: 'temp_marker',
      // styleId: 'mark_临时', // 使用临时标注点样式
      position: new window.TMap.LatLng(position.lat, position.lng),
      properties: {
        title: title
      }
    }

    // 创建临时商圈几何对象
    const circleGeometry = {
      id: 'temp_circle',
      styleId: 'circle_临时1', // 使用临时商圈样式
      center: new window.TMap.LatLng(position.lat, position.lng),
      radius: 5 * 500, // 默认5公里商圈
      properties: {
        title: title
      }
    }

    // 添加到临时图层
    this.tempLayer.setGeometries([markerGeometry])
    this.tempCircleLayer.setGeometries([circleGeometry])

    // 保存引用
    this.tempMarker = markerGeometry
    this.tempCircle = circleGeometry

    // 绑定点击事件
    this.bindTempMarkerClick()

    return {
      marker: markerGeometry,
      circle: circleGeometry
    }
  }

  /**
   * 绑定临时标注点点击事件
   */
  bindTempMarkerClick () {
    // 为临时标注点绑定点击事件
    this.tempLayer.on('click', (evt) => {
      const geometry = evt.geometry
      if (geometry.id === 'temp_marker') {
        // 发出临时标注点点击事件
        this.emit('temp-marker-click', {
          position: geometry.position,
          properties: geometry.properties
        })
      }
    })
  }

  /**
   * 清除临时标注点
   */
  clearTempMarker () {
    if (this.tempMarker || this.tempCircle) {
      this.tempLayer.setGeometries([])
      this.tempCircleLayer.setGeometries([])
      this.tempMarker = null
      this.tempCircle = null
    }
  }

  /**
   * 绘制行政区划边界
   * @param {string} code - 行政区划编码（adcode）
   * @param {number} level - 区划级别：0=省级 1=市级 2=区县级
   */
  async drawDistrictBoundary (code, level) {
    this.clearDistrictBoundary()

    if (!window.TMap || !window.TMap.service || !window.TMap.service.District) {
      this.emit('error', '行政区划服务未加载，请刷新页面重试')
      return
    }

    const district = new window.TMap.service.District({
      polygon: 2,
      maxOffset: 100
    })

    let areas = []
    try {
      const result = await district.search({ keyword: code })
      areas = result.result[0] || []
      // if (level === 2) {
      //   const result = await district.search({ keyword: code })
      //   areas = result.result[0] || []
      // } else {
      //   const result = await district.getChildren({ id: code })
      //   areas = result.result[0] || []
      // }
    } catch (err) {
      console.error('获取行政区划数据失败:', err)
      this.emit('error', '获取行政区划数据失败')
      return
    }

    if (areas.length === 0) {
      this.emit('error', '未找到该区划的边界数据')
      return
    }

    const styleId = level === 0 ? 'province' : (level === 1 ? 'city' : 'district')

    const geometries = []
    for (let i = 0; i < areas.length; i++) {
      if (!areas[i].polygon) continue
      for (let j = 0; j < areas[i].polygon.length; j++) {
        geometries.push({
          id: areas[i].id + '_' + j,
          styleId,
          paths: areas[i].polygon[j]
        })
      }
    }

    if (geometries.length === 0) {
      this.emit('error', '该区划暂无边界数据')
      return
    }

    this.polygonLayer.setGeometries(geometries)
    this.currentBoundaryCode = code
    this.fitBoundaryBounds(areas, level)
  }

  /**
   * 自动调整地图视野到边界范围
   */
  fitBoundaryBounds (areas, level) {
    if (!areas || areas.length === 0) return

    const first = areas.find(a => a.location)
    if (first && first.location) {
      const zoom = level === 0 ? 9 : (level === 1 ? 12 : 13)
      this.map.easeTo({
        center: new window.TMap.LatLng(first.location.lat, first.location.lng),
        zoom
      }, { duration: 500 })
    }
  }

  /**
   * 清除行政区划边界
   */
  clearDistrictBoundary () {
    if (this.polygonLayer) {
      this.polygonLayer.setGeometries([])
    }
    this.currentBoundaryCode = null
  }

  /**
   * 将地图移动到指定位置并设置缩放级别
   * @param {Object} position - 位置对象 {lat, lng}
   * @param {number} zoom - 缩放级别，默认11.5
   */
  moveToPosition (position, zoom = 11.5) {
    const targetZoom = this.map.getZoom() < zoom ? zoom : this.map.getZoom()
    this.map.easeTo({
      center: new window.TMap.LatLng(position.lat, position.lng),
      zoom: targetZoom
    })
  }

  /**
   * 设置地图鼠标样式
   * @param {string} cursor - 光标样式
   */
  setMapCursor (cursor) {
    // 使用腾讯地图GL JS的setCursorStyle方法
    if (this.map) {
      this.map.setCursorStyle(cursor)
    }
  }

  /**
   * 停止添加门店模式
   */
  stopAddStoreMode () {
    this.isAddingStore = false
    this.setMapCursor('default')
  }

  /**
   * 销毁地图实例和相关资源
   */
  destroy () {
    // 清理防抖定时器
    if (this._refreshTimer) {
      clearTimeout(this._refreshTimer)
      this._refreshTimer = null
    }

    // 清空图层数据
    if (this.markerLayer) {
      this.markerLayer.setGeometries([])
      this.markerLayer.off('click', this.onMarkerClick.bind(this))
    }
    if (this.circleLayer) {
      this.circleLayer.setGeometries([])
    }
    if (this.labelLayer) {
      this.labelLayer.setGeometries([])
      this.labelLayer.off('click', this.onLabelClick.bind(this))
    }

    // 销毁地图实例
    if (this.map) {
      this.map.off('click', this.onMapClick.bind(this))
      this.map.destroy()
      this.map = null
    }

    // 销毁图层
    this.markerLayer = null
    this.circleLayer = null
    this.labelLayer = null

    // 销毁测量工具
    this.measureTool = null

    // 清空门店数据
    this.storeList = []

    // 清理行政区划边界图层
    if (this.polygonLayer) {
      this.polygonLayer.setGeometries([])
      this.polygonLayer = null
    }

    // 清理添加门店模式
    this.stopAddStoreMode()

    // 清理临时标注点
    this.clearTempMarker()

    // 移除所有事件监听器
    this.removeAllListeners()
  }

  /**
   * 关闭标记点和标签的交互
   */
  disableInteraction () {
    this.markerLayer.setInteractiveDisable(true)
    this.labelLayer.setInteractiveDisable(true)
  }

  /**
   * 启用标记点和标签的交互
   */
  enableInteraction () {
    this.markerLayer.setInteractiveDisable(false)
    this.labelLayer.setInteractiveDisable(false)
  }
}

export default MapTools
